var React = require('react');

function FolderTransfer (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-4.67-8A.33.33 0 0 1 5 9.67V2.33A.33.33 0 0 1 5.33 2h3a.33.33 0 0 1 .32.23l.36 1.09A1 1 0 0 0 10 4h4.67c.183 0 .33.147.33.33v5.34a.33.33 0 0 1-.33.33zM19 16h-6.18A3 3 0 0 0 11 14.18V12h3.67A2.34 2.34 0 0 0 17 9.67V4.33A2.34 2.34 0 0 0 14.67 2h-4l-.13-.41A2.34 2.34 0 0 0 8.37 0h-3A2.34 2.34 0 0 0 3 2.31v7.36A2.34 2.34 0 0 0 5.33 12H9v2.18A3 3 0 0 0 7.18 16H1a1 1 0 1 0 0 2h6.18a2.999 2.999 0 0 0 5.64 0H19a1 1 0 1 0 0-2","fill":"#868797","fillRule":"evenodd"}));
}

FolderTransfer.defaultProps = {"width":"30","viewBox":"0 0 20 20"};

module.exports = FolderTransfer;

FolderTransfer.default = FolderTransfer;
